<template>
    <section class="section section-shaped section-lg m-0">
        <Loading v-if="loading"/>
        <div class="shape shape-style-1 shape-primary alpha-4">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container" style="padding-top: 0rem; !important ;top:0">
            <div class="row justify-content-center">
                <div class="col col-sm-5 col-xs-5 col-lg-5  col-md-5 my-4 ">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="py-5"
                          class="border-0">
                       
                        <template>
                            <div class="text-center">
                                <base-alert type="default" dismissible v-if="error">
                                <span class="alert-inner--text"><strong>Error!</strong> {{ error }} </span>
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </base-alert>
                                <!-- <img src="/img/settings.png" width="200"> -->
                                <h5>STAFF ATTENDANCE</h5>
                                <lottie-animation
                                    path="login.json"
                                    :width=230
                                    :speed=0.7
                                />
                            </div>
                            
                             <form  role="form" v-on:keyup.enter="onSubmit">
                                 <div class="text-danger text-center">
                                    <small v-if="!$v.email.required && $v.email.$anyDirty">Email is required</small>
                                    <small v-if="!$v.email.email">Email is invalid</small> 
                                </div>
                                <base-input alternative
                                            class="mb-3"
                                            placeholder="Email"
                                            v-model="email"
                                            :class="!$v.email.required && $v.email.$anyDirty || !$v.email.email ? 'shake border border-danger' : !$v.email.$invalid ? 'border border-success' : '' "
                                            :addon-left-icon="!$v.email.required && $v.email.$anyDirty || !$v.email.email ? 'ni ni-email-83  text-danger' :'ni ni-email-83' " 
                                         >
                                </base-input>
                                
                                 <div class="text-danger text-center">
                                    <small v-if="!$v.password.required && $v.password.$anyDirty">Password is required</small>
                                </div>
                                <base-input alternative
                                            type="password"
                                            v-model="password"
                                            placeholder="Password"
                                            :class="!$v.password.required && $v.password.$anyDirty  ? 'shake border border-danger' : !$v.password.$invalid ? 'border border-success' : '' "
                                            :addon-left-icon="!$v.password.required && $v.password.$anyDirty  ? 'ni ni-lock-circle-open  text-danger' :'ni ni-lock-circle-open' " 
                                            >
                                </base-input>
                               
                                
                                <div class="text-center">
                                    <base-button type="primary" @click="onSubmit"  class="my-3">Sign In</base-button>
                                </div>

                                <div class="text-center">
                                    <router-link to="register">No account ? Register here</router-link>
                                </div>

                            

                                
                            </form>
                        </template>
                    </card>
                    
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"
import { required, email } from 'vuelidate/lib/validators'
import Loading from './Loading'

export default {
  name:'Login',
  components:{
        Loading,
        LottieAnimation
    },
   
  data () {
    return {
      email: '',
      password: '',
      loading:false,
      error:''
    }
  },
  validations () {
    return {
      email: { required, email }, 
      password: { required }
      
    }
  },
  methods:{

      onSubmit(){
            
            this.$v.$touch();
            if(this.$v.$error) return

            // to form submit after this
            this.loading=true
            fetch(`${process.env.VUE_APP_APIURL}/login/tasks`, 
            {
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body : JSON.stringify({ "email":this.email , "password":this.password })
            })
            .then(response => response.json())
            .then(data => {

                setTimeout(() => {

                    this.loading=false
                    if(data.success){

                    this.$store.dispatch('login',{...data,expiry: (new Date().getTime() + 360*60000)})
                    this.$router.push({ name: 'report' })
                    
                    }else{

                    this.error = data.message ?  data.message : data.error
                  }
                    
                    }, 2000);

                
                
            })
            .catch(err => {
                setTimeout(() => {
                    this.loading=false
                    this.error="Something went wrong."
                }, 2000);
            });

      }
  }
    
};
</script>
<style>
</style>
